import { useEffect } from 'react';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';

export const useCheckCameraPermission = (shouldOpenSettings?: boolean) => {
  useEffect(() => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'permission', messageParam: 'camera', messageData: { shouldOpenSettings } });
    }
  }, []);
};
